const errors = new Map<string, string>([
  ["Unauthorized", "Unauthorized Credentials"],
  ["INVALID_CREDENTIALS", "Invalid email or password"],
  ["USER_NOT_FOUND", "User not found"],
  ["ACCOUNT_LOCKED", "Account has been locked"],
  ["INVALID_TOKEN", "Invalid or expired token"],
  ["PERMISSION_DENIED", "You don't have permission to perform this action"],
  ["VALIDATION_ERROR", "Invalid input data"],
  ["DUPLICATE_ENTRY", "This entry already exists"],
  ["RESOURCE_NOT_FOUND", "Requested resource not found"],
  ["RATE_LIMIT_EXCEEDED", "Too many requests. Please try again later"],
  ["MAINTENANCE_MODE", "System is under maintenance. Please try again later"],
]);

export type DEFAULT_STATUS_TYPE = "idle" | "loading" | "succeeded" | "failed";

export const DEFAULT_ERROR_MESSAGE =
  "An error occurred, please try again later";

export default function mapCodeToErrorText(code?: string): string {
  if (!code) return DEFAULT_ERROR_MESSAGE;
  const text = errors.get(code);
  return text || DEFAULT_ERROR_MESSAGE;
}
